export const akanClans = [
  {
    id: 'oyoko',
    name: 'Oyoko',
    totem: 'Hawk / Falcon',
    symbol: '🦅',
    color: '#C9A558',
    tagline: 'The Royal Clan',
    description: 'The most prestigious clan of the Ashanti Kingdom. The Oyoko produced the most Asantehenes (Ashanti kings), including the legendary Osei Tutu I who founded the Ashanti Empire in the late 17th century. Their authority is tied to the Golden Stool — the sacred throne that holds the soul of the Ashanti nation.',
    traits: ['Natural leadership', 'Royal authority', 'Strategic intelligence', 'Fierce protectiveness of their people'],
    taboo: 'Members do not eat the hawk, crow, or eagle — their totemic birds.',
    matrilinealNote: 'The chieftaincy of the Ashanti Kingdom passes through the Oyoko female line. A chief\'s successor is always his nephew (sister\'s son), never his own son.',
    spiritualNote: 'The Oyoko are believed to have a direct channel to Nyame (the Supreme God) and are entrusted with the spiritual guardianship of the entire kingdom.',
    diasporaResonance: 'If your mother\'s lineage traces to the Ashanti region, you may carry Oyoko blood. The royal dignity of this clan belongs to you wherever you are in the world.',
  },
  {
    id: 'aduana',
    name: 'Aduana',
    totem: 'Dog / Sacred Fire',
    symbol: '🔥',
    color: '#e07020',
    tagline: 'The First People',
    description: 'The oldest of all Akan clans, believed to be the first people on earth. The Aduana are associated with sacred fire — they are the original custodians of the land and keepers of the eternal flame. Their antiquity commands deep respect across all Akan communities.',
    traits: ['Ancient wisdom', 'Loyalty and devotion', 'Custodians of land and tradition', 'Deep ancestral connection'],
    taboo: 'Members do not eat dog meat, as the dog is their sacred totem. They also do not let fire be extinguished without ceremony.',
    matrilinealNote: 'As the oldest clan, the Aduana hold special customary rights in land ownership. Land disputes involving the Aduana carry enormous historical weight.',
    spiritualNote: 'Their sacred fire represents the eternal flame of life and the unbroken thread connecting the living to the ancestors. Their ceremonies involve lighting and maintaining fire.',
    diasporaResonance: 'Carrying Aduana blood means you carry the oldest memory of the Akan people. You are a keeper of the original flame.',
  },
  {
    id: 'asona',
    name: 'Asona',
    totem: 'Crow / Raven',
    symbol: '🐦‍⬛',
    color: '#6a6a9a',
    tagline: 'The Intellectuals',
    description: 'The clan of intellectuals, diplomats, and orators. The Asona are renowned throughout Akan society as skilled communicators, wise counselors, and peace-brokers. They are the keepers of oral history and are frequently chosen as royal linguists and spokespersons.',
    traits: ['Eloquence and oratory', 'Diplomatic intelligence', 'Historical memory', 'Peace-brokering'],
    taboo: 'Members do not eat crow or ravens — their totem birds.',
    matrilinealNote: 'Many Asona women have historically served as queen mothers (Ohemaa), wielding significant political power as kingmakers in Akan governance.',
    spiritualNote: 'The crow carries messages between the living and the ancestors — making the Asona natural mediators between worlds and keepers of ancestral communication.',
    diasporaResonance: 'If you have always felt drawn to words, history, or bringing people together, you may be channelling ancient Asona energy.',
  },
  {
    id: 'asenie',
    name: 'Asenie',
    totem: 'Bat',
    symbol: '🦇',
    color: '#7a3a9a',
    tagline: 'The Night Seers',
    description: 'The clan of mystery, night wisdom, and hidden knowledge. The Asenie possess deep spiritual insight and the ability to navigate complex situations that others find confusing or dark. Like the bat that sees perfectly in total darkness, the Asenie perceive what others cannot.',
    traits: ['Deep spiritual perception', 'Mystery and intuition', 'Navigating darkness', 'Hidden knowledge'],
    taboo: 'Members do not eat bat meat.',
    matrilinealNote: 'The Asenie clan has historically produced many of the Akan\'s most powerful priests (Okomfo) and spiritualists, with knowledge passed through the female line.',
    spiritualNote: 'The bat\'s navigation through complete darkness is a metaphor for the Asenie\'s ability to find truth in confusion. They are called to illuminate what others fear to see.',
    diasporaResonance: 'Asenie souls often feel like they see things others miss — spiritual depth and perception are your inheritance.',
  },
  {
    id: 'bretuo',
    name: 'Bretuo / Tena',
    totem: 'Leopard',
    symbol: '🐆',
    color: '#c8860b',
    tagline: 'The Warriors',
    description: 'The warrior clan, fierce and powerful. The Bretuo (also called Tena) are associated with the leopard — strength, speed, and lethal precision. Historically the military arm of Akan kingdoms, they produced the greatest war commanders and most feared fighters in West Africa.',
    traits: ['Fierce physical bravery', 'Military excellence', 'Precision and speed', 'Commanding presence'],
    taboo: 'Members do not eat leopard or any big cat.',
    matrilinealNote: 'In wartime, Bretuo women were expected to encourage their sons into battle and were known for their own fierce pride and courage. Military valor is a matrilineal inheritance.',
    spiritualNote: 'The leopard is the highest symbol of power in Akan culture. To call someone "Osebo" (leopard) is to give them the greatest compliment a warrior can receive.',
    diasporaResonance: 'If you feel a burning drive to fight for justice, lead others, or protect the vulnerable — the Bretuo warrior spirit lives in you.',
  },
  {
    id: 'agona',
    name: 'Agona',
    totem: 'Parrot',
    symbol: '🦜',
    color: '#2e8b57',
    tagline: 'The Creatives',
    description: 'The clan of communication, creativity, and cultural expression. The Agona are gifted in music, art, storytelling, and cultural preservation. Like the parrot that speaks many languages, the Agona are natural bridge-builders between communities and cultures.',
    traits: ['Creative gifts', 'Musical and artistic talent', 'Cross-cultural communication', 'Cultural guardianship'],
    taboo: 'Members do not eat parrot meat.',
    matrilinealNote: 'The Agona are among the most widespread Akan clans. Their creative gifts and outgoing nature have taken them across West Africa and beyond.',
    spiritualNote: 'The parrot\'s ability to speak is seen as a divine gift. The Agona are believed to carry the voice of the ancestors and are often the griots, praise-singers, and drummers of Akan society.',
    diasporaResonance: 'Agona energy flows through every Black musician, artist, storyteller, and cultural ambassador. If creativity lives in your bones, you may carry this lineage.',
  },
  {
    id: 'ekuona',
    name: 'Ekuona',
    totem: 'Buffalo / Bull',
    symbol: '🐃',
    color: '#8b4513',
    tagline: 'The Community Builders',
    description: 'The clan of strength, endurance, and community building. The Ekuona are associated with the buffalo — powerful, communal, and unstoppable when moving together. They are historically the farmers, builders, and sustainers of Akan communities.',
    traits: ['Raw physical strength', 'Community devotion', 'Endurance through hardship', 'Dependability and loyalty'],
    taboo: 'Members do not eat buffalo or bull meat.',
    matrilinealNote: 'Ekuona women have historically been the backbone of Akan agricultural communities — managing farms, feeding families, and maintaining the economic life of villages.',
    spiritualNote: 'The buffalo\'s communal nature — protecting the herd at all costs — reflects the Ekuona\'s deep commitment to family and community over individual gain.',
    diasporaResonance: 'If you feel called to build, to provide, to sustain your community — you carry Ekuona strength in your blood.',
  },
  {
    id: 'kona',
    name: 'Kona / Asakyiri',
    totem: 'Vulture',
    symbol: '🦅',
    color: '#696969',
    tagline: 'The Purifiers',
    description: 'The clan of purification, transformation, and renewal. Though the vulture is misunderstood by many cultures, in Akan cosmology it holds the sacred role of purifying the land and facilitating the cycle of life, death, and rebirth. The Kona are agents of transformation.',
    traits: ['Spiritual purification', 'Transformation and renewal', 'Cycles of death and rebirth', 'Sacred cleansing'],
    taboo: 'Members do not eat vulture meat.',
    matrilinealNote: 'The Kona are often involved in funeral rites and ancestral ceremonies. Their matrilineal knowledge includes sacred cleansing rituals passed through generations of women.',
    spiritualNote: 'The vulture\'s role in consuming what others leave behind is a sacred purification act in Akan cosmology. The Kona facilitate the soul\'s journey between worlds.',
    diasporaResonance: 'If you are drawn to healing, to releasing the old, to facilitating transformation in others — Kona energy may be your ancestral calling.',
  },
];
